/* eslint-disable */
import React from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import cookie from "react-cookies";
import { Pagination, PaginationItem } from "reactstrap";
import { GET_CATEGORIES, GET_MERCHANTS, GET_DEALS } from "../../actions";
import { page_limit } from "../Config/config";
import { Helmet } from "react-helmet";
import {
  language,
  site_title,
  checkauthentication,
  getImage,
  LoadingSec,
  headerDetails,
  Encrypt,
  IntialLoading,
  DisplayContent
} from "../Config/Helpers";
import mlogolg_kfc from "../../common/images/mlogolg-kfc.png";

class Merchantdeals extends React.Component {
  constructor(props) {
    super(props);
    if (checkauthentication() === false) {
      const { history } = this.props;
      history.push("/login");
    }
    this.state = {
      selectedOption: null,
      selectedOptionRec: null,
      searchactive: false,
      frmloading: true,
      categoryoption: [],
      userdetails: cookie.load("user_details"),
      lang: language(),
      deallist: "",
      pagenation: "",
      page: 1,
      search_keyword: "",
      merchant_details: "",
      merchant_name: "",
      merchant_photo: "",
      merchantDetails: [],
      filtererchant:
        this.props.match.params !== "" &&
        typeof this.props.match.params !== "undefined" &&
        this.props.match.params.merchantID !== "" &&
        typeof this.props.match.params.merchantID !== "undefined"
          ? this.props.match.params.merchantID
          : ""
    };
  }

  componentDidMount() {
    this.props.getCategories();
    this.props.getMerchants();
    let merchant_id = "";
    if (this.state.filtererchant !== "") {
      merchant_id = "&merchant_id=" + Encrypt(this.state.filtererchant, "d");
    }

    let params = "page=" + this.state.page + merchant_id;
    this.props.getDeals(params);
  }

  componentDidUpdate(prevProps) {
    if (this.props.dealdata !== prevProps.dealdata) {
      /* Deals Response */
      this.setState({ frmloading: false });
      if (
        this.props.dealdata.status !== "" &&
        typeof this.props.dealdata.status !== "undefined" &&
        typeof this.props.dealdata.status !== undefined
      ) {
        if (this.props.dealdata.status === false) {
          const { history } = this.props;
          history.push("/logout");
        } else if (this.props.dealdata.status === "ok") {
          if (
            this.props.dealdata.total_records !== "" &&
            typeof this.props.dealdata.total_records !== "undefined" &&
            typeof this.props.dealdata.total_records !== undefined
          ) {
            this.setState(
              { total_records: this.props.dealdata.total_records },
              function() {
                this.loadPagenation();
              }
            );
          }
          this.setState(
            {
              deal_details: this.props.dealdata.result_set,
              merchant_name: this.props.dealdata.merchant_name,
              merchant_photo: this.props.dealdata.merchant_photo
            },
            function() {
              this.loadDeails();
              this.loadPagenation();
            }
          );
        }
      }
    }
    /* Category Resoponse */
    if (this.props.categorydata !== prevProps.categorydata) {
      if (
        this.props.categorydata.status !== "" &&
        typeof this.props.categorydata.status !== "undefined"
      ) {
        if (this.props.categorydata.status === "ok") {
          this.setState({ categoryoption: this.props.categorydata.result_set });
        }
      }
    }

    if (this.props.merchantdata !== prevProps.merchantdata) {
      /* Merchants Response */
      this.setState({ frmloading: false });
      if (
        this.props.merchantdata.status !== "" &&
        typeof this.props.merchantdata.status !== "undefined" &&
        typeof this.props.merchantdata.status !== undefined
      ) {
        if (this.props.merchantdata.status === false) {
          const { history } = this.props;
          history.push("/logout");
        } else if (this.props.merchantdata.status === "ok") {
          this.setState(
            { merchant_details: this.props.merchantdata.result_set },
            function() {
              this.loadMerchant();
            }
          );
        }
      }
    }
  }
  /* Set Value for Category */
  handleChange = selectedOption => {
    this.setState({ selectedOption }, function() {
      this.applyFilter();
    });
  };
  /* Set Value for Merchant Drobdown */
  handleChangeRec = selectedOptionRec => {
    this.setState({ selectedOptionRec }, function() {
      this.applyFilter();
    });
  };
  /* Show/hide Search textbox */
  toggleSearch() {
    if (this.state.searchactive === true) {
      this.applyFilter();
    }

    this.setState(prevState => ({
      searchactive: !prevState.searchactive
    }));
  }
  /* Set State for textbox value */
  handleChangeTxt = event => {
    let { name, value } = event.target;
    this.setState({ [name]: value });
  };
  /* Find the search key */
  handleKeyUp(e) {
    var unicode = e.keyCode ? e.keyCode : e.charCode;
    if (unicode === 13) {
      this.applyFilter();
    }
  }
  /* Remove Seatch Text */
  removeSearch() {
    this.setState({ search_keyword: "" });
  }

  loadMerchant() {
    let merchantDetails = [];
    let selectedOptionRec = [];
    if (
      this.state.merchant_details !== "" &&
      typeof this.state.merchant_details !== "undefined"
    ) {
      this.state.merchant_details.map(item => {
        if (this.state.filtererchant !== "") {
          let filtererchant = Encrypt(this.state.filtererchant, "d");
          if (filtererchant === item.merchant_id) {
            selectedOptionRec = {
              value: item.merchant_id,
              label: item.merchant_name
            };
          }
        }

        merchantDetails.push({
          value: item.merchant_id,
          label: item.merchant_name
        });
        return "";
      });
      this.setState({
        merchantDetails: merchantDetails,
        selectedOptionRec: selectedOptionRec
      });
    }
  }

  /* Load Deals List */
  loadDeails() {
    let deallist;
    if (
      this.state.deal_details !== "" &&
      typeof this.state.deal_details !== "undefined"
    ) {
      deallist = this.state.deal_details.map((item, index) => {
        return (
          <div className="item_row" key={index}>
            <Link to={"/deal-detail/" + Encrypt(item.deal_id, "e")}>
              <div className="item_img">
                {item.hot_deals === "Y" && (
                  <span className="offer_label deal_status deal_status_hot ">
                    {this.state.lang.home.hot_deals}
                  </span>
                )}
                <img src={getImage(item.deal_image, "deals")} alt="" />
              </div>
              <div className="item_info">
                <h3>{item.deal_name}</h3>
                <p className="deal_buyoff">
                  {item.description !== "" && item.description !== null
                    ? DisplayContent(item.description)
                    : ""}
                </p>
                <p className="deal_loc">
                  {item.location}{" "}
                  {item.location > 1
                    ? this.state.lang.deals.locations
                    : this.state.lang.deals.location}
                </p>
                <span className="deals_coins">
                  <i className="ico_r text-lowercase"></i>
                  {item.coin}
                </span>
              </div>
            </Link>
          </div>
        );
      });
    } else {
      this.setState({ total_records: 0 }, function() {
        this.loadPagenation();
      });
      deallist = (
        <div className="norecord_sec text-center">
          <i className="norecord_ico"></i>
          <h4>{this.state.lang.deals.no_deals}</h4>
        </div>
      );
    }
    this.setState({ deallist: deallist });
  }
  /* Load Pagenation Desaign */
  loadPagenation() {
    let total_records = this.state.total_records;
    let totalPage = total_records / page_limit;
    let pagenation = "";
    let prev = this.state.page - 1;
    let next = parseInt(this.state.page) + 1;
    if (Math.ceil(totalPage) > 1) {
      pagenation = (
        <Pagination aria-label="Page navigation example">
          {this.state.page > 1 && (
            <PaginationItem onClick={this.loadMore.bind(this, prev)}>
              <span
                className="page-link"
                aria-label={this.state.lang.common.prev}
              >
                <span aria-hidden="true">‹</span>
                <span className="sr-only">{this.state.lang.common.prev}</span>
              </span>
            </PaginationItem>
          )}
          {this.loadpageList()}
          {parseInt(this.state.page) + 1 <= Math.ceil(totalPage) && (
            <PaginationItem onClick={this.loadMore.bind(this, next)}>
              <span
                href="#"
                className="page-link"
                aria-label={this.state.lang.common.next}
              >
                <span aria-hidden="true">›</span>
                <span className="sr-only">{this.state.lang.common.next}</span>
              </span>
            </PaginationItem>
          )}
        </Pagination>
      );
    }
    this.setState({ pagenation: pagenation });
  }

  /* Pagenation Number List */
  loadpageList() {
    let currentPage = this.state.page > 1 ? parseInt(this.state.page) - 1 : 1;
    let total_records = this.state.total_records;
    let totalPage = total_records / page_limit;
    let nextloop =
      parseInt(currentPage) + 3 <= totalPage
        ? parseInt(currentPage) + 3
        : totalPage;
    if (currentPage - nextloop <= 3) {
      currentPage = nextloop - 3;
      if (currentPage <= 0) {
        currentPage = 1;
      }
    }
    let ToReturn = [];
    for (var i = Math.ceil(currentPage); i <= Math.ceil(nextloop); i++) {
      ToReturn.push(
        <PaginationItem
          key={i}
          className={this.state.page === i ? "active" : ""}
          onClick={this.loadMore.bind(this, i)}
        >
          <span className="page-link">{i}</span>
        </PaginationItem>
      );
    }
    return ToReturn;
  }

  /* Apply Filter*/
  applyFilter() {
    this.setState({ page: 1, frmloading: true }, function() {
      let category_id =
        this.state.selectedOption !== null
          ? this.state.selectedOption.value
          : "";
      let recommended =
        this.state.selectedOptionRec !== null &&
        this.state.selectedOptionRec !== "undefined" &&
        this.state.selectedOptionRec.value !== "undefined"
          ? this.state.selectedOptionRec.value
          : "";
      let merchantID = typeof recommended !== "undefined" ? recommended : "";
      let params =
        "page=" +
        this.state.page +
        "&category_id=" +
        category_id +
        "&merchant_id=" +
        merchantID +
        "&search_keyword=" +
        this.state.search_keyword;
      this.props.getDeals(params);
    });
  }

  /* Apply Pagenation */
  loadMore(page) {
    if (page !== this.state.page) {
      this.setState({ page: page, frmloading: true }, function() {
        let category_id =
          this.state.selectedOption !== null
            ? this.state.selectedOption.value
            : "";
        let recommended =
          this.state.selectedOptionRec !== null
            ? this.state.selectedOptionRec.value
            : "";
        let params =
          "page=" +
          this.state.page +
          "&category_id=" +
          category_id +
          "&recommended=" +
          recommended +
          "&search_keyword=" +
          this.state.search_keyword;
        this.props.getDeals(params);
      });
    }
  }

  render() {
    if (
      this.state.userdetails !== "" &&
      typeof this.state.userdetails !== "undefined"
    ) {
      const { selectedOption, selectedOptionRec } = this.state;
      return (
        <div className="center grow_flex">
          <Helmet>
            <title>{site_title(this.state.lang.deals.title)}</title>
            <meta name="keywords" content={this.state.lang.deals.title} />
            <meta name="description" content={this.state.lang.deals.title} />
          </Helmet>
          {headerDetails()}
          <div className="details_topbar">
            <Link
              to={"/merchants"}
              className="back_arrow title2"
              title={this.state.merchant_name}
            >
              {this.state.merchant_name}
            </Link>
          </div>
          <div className="merchant_banimg">
            <img src={getImage(this.state.merchant_photo, "merchant")} alt="" />
          </div>
          <div
            className={
              this.state.frmloading === true
                ? "item_list load_wrapper load-wrapper-mheight"
                : "item_list"
            }
          >
            {this.state.frmloading === true && LoadingSec()}
            {this.state.deallist}
          </div>
          {this.state.pagenation !== "" && (
            <div className="pagination_sec">{this.state.pagenation}</div>
          )}
        </div>
      );
    } else {
      return IntialLoading();
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getCategories: () => {
      dispatch({ type: GET_CATEGORIES });
    },
    getDeals: params => {
      dispatch({ type: GET_DEALS, params });
    },
    getMerchants: param => {
      dispatch({ type: GET_MERCHANTS, param });
    }
  };
};

const mapStateToProps = state => {
  return {
    categorydata: state.categorydata,
    dealdata: state.dealdata,
    merchantdata: state.merchantdata
  };
};

Merchantdeals.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  })
};

Merchantdeals = connect(mapStateToProps, mapDispatchToProps)(Merchantdeals);

export default withRouter(Merchantdeals);
